import type { TFunction } from 'i18next';
import type { CustomFieldDtoFieldType } from 'services/custom-fields/schemas';

export const formatFieldType = (type: CustomFieldDtoFieldType, t: TFunction) => {
  switch (type) {
    case 'text':
      return t('settings.legacy.custom_fields.field_type_text');
    case 'number':
      return t('settings.legacy.custom_fields.field_type_number');
    case 'date':
      return t('settings.legacy.custom_fields.field_type_date');
    case 'boolean':
      return t('settings.legacy.custom_fields.field_type_boolean');
    case 'dropdown':
      return t('settings.legacy.custom_fields.field_type_dropdown');
    default:
      return type;
  }
};
